import { Navigate, useLocation } from 'react-router';
import { redirectFor } from '@platform/shared';
import { NotFoundPage } from './NotFoundPage';

/**
 * The SPA's side of the redirect table (planning-app.md §3 *Navigation from v3.8*, PA62a): an old
 * room path reached by a client-side navigation lands where the API's 301 would have sent a fresh
 * load, query string and all; anything else is the 404.
 */
export function LegacyRedirect() {
  const location = useLocation();
  const target = redirectFor(location.pathname, location.search);
  if (target) return <Navigate to={target} replace />;
  return <NotFoundPage />;
}
